import React from 'react';
import './Sections.css';

const ResilienceTester = () => {
  return (
    <div className="rsiliencetester-container">
      <div className="text-box">
        <div className="inner-box" dir="rtl">
          <h2>בודק החוסן שלכם</h2>
          <p>פרילנסר מקצועי עם התמחות בבדיקות חוסן וחדירות למערכות מידע, בעל ידע מעמיק באיתור וסגירת פרצות אבטחה.</p>
          <p>בוגר הכשרות מתקדמות בתחום הסייבר, עם הבנה מעמיקה במתודולוגיות בדיקה ובכלים טכנולוגיים עדכניים. מחפש להצטרף לצוות מקצועי בתחום בדיקות החוסן.</p>
          <p>יכולות מוכחות בתחומי: סריקת פגיעויות, בדיקות חדירה, והבנת סיכונים. בעל גישה אנליטית, למידה מהירה ומוטיבציה גבוהה להתפתחות מקצועית. מחויב לאבטחת מערכות ברמה הגבוהה ביותר ולשיתוף פעולה אפקטיבי עם צוותי פיתוח ותשתיות.</p>
        </div>
      </div>
    </div>
  );
};

export default ResilienceTester;
